import { computed, onMounted, ref } from "vue";
import { useStore } from "@/store";
import { getValuesInBetween } from "./utils/delegationBoardRecodsHelper";

export const lendingAssessorDelegationBoard = () => {
  const store = useStore();

  const sideMenuCollapsed = computed(() => store.state.main.sideMenuCollapsed);

  const adminUser = computed(() => store.state.auth.loggedUser);

  function onClickResolveAppDetailsAndReRoute(applicationId) {
    store.dispatch(
      "lnAppDtsRouter/resolveAndReRouteLnAssessmentDtsPage",
      applicationId
    );
  }

  const busy = computed(() => store.state.lnAssessorDelegBrd.busy);

  const agentNameForFilter = ref("");

  const selectedAgent = computed(
    () => store.state.lnAssessorDelegBrd.selectedAgent
  );

  const lendingAgents = computed(
    () => store.state.lnAssessorDelegBrd.lendingAgents
  );

  const fetchingLendingAgents = computed(
    () => store.state.lnAssessorDelegBrd.fetchingLendingAgents
  );

  const unassignedLoans = computed(
    () => store.state.lnAssessorDelegBrd.unassignedLoans
  );

  const fetchingUnassignedLoans = computed(
    () => store.state.lnAssessorDelegBrd.fetchingUnassignedLoans
  );

  const selectedUnassignedLoans = computed(
    () => store.state.lnAssessorDelegBrd.selectedUnassignedLoans
  );

  function toggleInsertionToAssignmentSelectionBag(id, massSelection = false) {
    let entries = [];

    if (selectedAgent.value > 0) {
      //If mass selection applied
      if (massSelection && selectedUnassignedLoans.value.length) {
        let lastEntry =
          selectedUnassignedLoans.value[
            selectedUnassignedLoans.value.length - 1
          ];
        if (lastEntry === id) return false;
        entries = getValuesInBetween({
          records: unassignedLoans.value,
          start: lastEntry,
          end: id,
          reverse: selectedUnassignedLoans.value.includes(id)
        });
      } else {
        entries = getValuesInBetween({
          records: unassignedLoans.value,
          start: id
        });
      }
      entries.forEach(value => {
        if (selectedUnassignedLoans.value.includes(value)) {
          store.commit(
            "lnAssessorDelegBrd/removeFromSelectedUnassignedLoans",
            value
          );
        } else {
          store.commit(
            "lnAssessorDelegBrd/pushToSelectedUnassignedLoans",
            value
          );
        }
      });
    }
  }

  function removeFromSelectedUnassignedLoans(id) {
    store.commit("lnAssessorDelegBrd/removeFromSelectedUnassignedLoans", id);
  }

  function emptySelectedUnassignedLoansBag() {
    store.commit("lnAssessorDelegBrd/clearSelectedUnassignedLoans");
  }

  const selectedAssignedLoans = computed(
    () => store.state.lnAssessorDelegBrd.selectedAssignedLoans
  );

  function toggleInsertionToUnAssignmentSelectionBag(
    assessmentRecord,
    delegation_allowed_statuses
  ) {
    if (delegation_allowed_statuses.includes(assessmentRecord.status)) {
      if (selectedAssignedLoans.value.includes(assessmentRecord.uuid)) {
        store.commit(
          "lnAssessorDelegBrd/removeFromSelectedAssignedLoans",
          assessmentRecord.uuid
        );
      } else {
        store.commit(
          "lnAssessorDelegBrd/pushToSelectedAssignedLoans",
          assessmentRecord.uuid
        );
      }
    }
  }

  function removeFromSelectedAssignedLoans(id) {
    store.commit("lnAssessorDelegBrd/removeFromSelectedAssignedLoans", id);
  }

  function emptySelectedAssignedLoansBag() {
    store.commit("lnAssessorDelegBrd/clearSelectedAssignedLoans");
  }

  function setSelectedAgent(id) {
    store.commit("lnAssessorDelegBrd/setSelectedAgent", id);
  }

  function selectAllUnassigned() {
    store.commit("lnAssessorDelegBrd/setAllUnassignedLoansForSelection");
  }
  function assignSelectedUnassigned(agentId) {
    if (selectedAgent.value < 1 || selectedUnassignedLoans.value.length < 1) {
      store.dispatch("globalToastMessage/showSimpleToast", {
        message:
          "Both Agent and Applications must be selected for assignment !",
        type: "warning"
      });
    } else {
      store.commit("main/setFullPageLoading");
      store.dispatch(
        "lnAssessorDelegBrd/submitUnassignedApplicationsForAssignment",
        agentId
      );
    }
  }

  function unassignSelectedAssigned(agentId) {
    if (selectedAssignedLoans.value.length < 1) {
      store.dispatch("globalToastMessage/showSimpleToast", {
        message:
          "Both Agent and Applications must be selected for Un-Assignment !",
        type: "warning"
      });
    } else {
      store.commit("main/setFullPageLoading");
      store.dispatch(
        "lnAssessorDelegBrd/submitAssignedApplicationsForUnassignment",
        agentId
      );
    }
  }

  function resetAgentSelection() {
    store.commit("lnAssessorDelegBrd/setSelectedAgent", 0);
    emptySelectedUnassignedLoansBag();
  }

  function getLendingAgents() {
    store.dispatch(
      "lnAssessorDelegBrd/getLendingAssessorAdminsWithAssociationsForLendingBoard"
    );
    store.dispatch(
      "lnAssessorDelegBrd/getUnassignedLoansForLendingAssessorAssignment"
    );
  }

  function clearAgentFilter() {
    agentNameForFilter.value = "";
    store.commit(
      "lnAssessorDelegBrd/setFilteredAgentName",
      agentNameForFilter.value
    );
    store.dispatch(
      "lnAssessorDelegBrd/getLendingAssessorAdminsWithAssociationsForLendingBoard"
    );
  }
  function submitAgentFilter() {
    store.commit(
      "lnAssessorDelegBrd/setFilteredAgentName",
      agentNameForFilter.value
    );
    if (agentNameForFilter.value !== "")
      store.dispatch(
        "lnAssessorDelegBrd/getLendingAssessorAdminsWithAssociationsForLendingBoard"
      );
  }

  onMounted(() => {
    getLendingAgents();
  });

  return {
    adminUser,
    agentNameForFilter,
    clearAgentFilter,
    submitAgentFilter,
    fetchingLendingAgents,
    lendingAgents,
    unassignedLoans,
    fetchingUnassignedLoans,
    selectedUnassignedLoans,
    selectedAssignedLoans,
    toggleInsertionToAssignmentSelectionBag,
    toggleInsertionToUnAssignmentSelectionBag,
    removeFromSelectedUnassignedLoans,
    removeFromSelectedAssignedLoans,
    emptySelectedUnassignedLoansBag,
    emptySelectedAssignedLoansBag,
    selectAllUnassigned,
    assignSelectedUnassigned,
    unassignSelectedAssigned,
    selectedAgent,
    setSelectedAgent,
    resetAgentSelection,
    onClickResolveAppDetailsAndReRoute,
    busy,
    sideMenuCollapsed
  };
};
